import React, { useEffect } from "react";
import { ServiceCenterForm } from "./Forms/ServiceCenterForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneServiceCenterQuery,
  useUpdateServiceCenterMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { FormSkeleton } from "./FormFieldSkeletons";

const getSystemFromPath = (pathname) =>
  pathname?.includes("madina") ? "madina" : "makkah";

export const EditServiceCenter = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const system = getSystemFromPath(location.pathname);

  const { id } = useParams();
  const {
    data: serviceCenterResponse,
    isLoading,
    isFetching,
  } = useGetOneServiceCenterQuery({ id }, { system });
  const serviceCenter = serviceCenterResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateServiceCenter, isPending } = useUpdateServiceCenterMutation(setError, { system });

  const onSubmit = (data) => {
    const payload = {
      id: serviceCenter?.id,
      code: data.code,
      name_ar: data.name_ar,
      name_en: data.name_en,
      address: data.address,
      phone: data.phone,
      manager_id: data.manager_id ?? null,
      ...(system === "madina" && {
        nationality_id: data.nationality_id ?? null,
      }),
    };
    updateServiceCenter(payload);
  };

  useEffect(() => {
    if (serviceCenter) {
      const formData = {
        ...serviceCenter,
        name_ar: serviceCenter.name_ar ?? serviceCenter.name ?? "",
        name_en: serviceCenter.name_en ?? serviceCenter.name ?? "",
        code: serviceCenter.code ?? "",
        address: serviceCenter.address ?? "",
        phone: serviceCenter?.phone ?? "",
        manager_id: serviceCenter?.manager?.id || null,
        nationality_id: serviceCenter.nationality_code,
      };
      reset(formData);
    }
  }, [serviceCenter, reset]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_SERVICE_CENTER")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <ServiceCenterForm control={control} errors={errors} system={system} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_SERVICE_CENTER")}
                  </>
                ) : (
                  t("UPDATE_SERVICE_CENTER")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};

